<div class="row mr-0 mocap-bg">
    <div #heroBanner id="hero-container" class="col-12 hero-container pr-0">
        <img class="w-100 d-none d-md-block" src="{{heroWebImage}}" alt="Hero Image" />
        <img class="w-100 d-md-none" src="{{heroMobileImage}}" alt="Hero Image" />
    </div>
</div>